/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_AnnotationInputs */

const cs_projects_annotation = /** @type {(inputs: Projects_AnnotationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anotace`)
};

const en_projects_annotation = /** @type {(inputs: Projects_AnnotationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annotation`)
};

/**
* | output |
* | --- |
* | "Annotation" |
*
* @param {Projects_AnnotationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_annotation = /** @type {((inputs?: Projects_AnnotationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_AnnotationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_annotation(inputs)
	return cs_projects_annotation(inputs)
});